import { Component, HostListener, NgZone, OnDestroy, OnInit, ViewEncapsulation, AfterContentChecked, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EditQuestionnaireTitleModalComponent } from './components/edit-questionnaire-name/edit-questionnaire-title-modal.component';
import { AddQuestionModalComponent } from '../../components/add-question-modal/add-question-modal.component';
import { QuestionnaireUserPermissionModalComponent } from '../../components/questionnaire-user-permission-modal/questionnaire-user-permission-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { QuestionnaireService } from '../../services/questionnaire/questionnaire.service';
import { AlertBannerService, AlertType } from '../../lib/alert-banner/alert-banner.service';
import { OrganisationService } from '../../services/organisation/organisation.service';
import { ConstantsService } from '../../services/constants/constants.service';
import * as Cookies from 'js-cookie';
import moment from 'moment-timezone';
import { MetricIconService } from 'src/app/services/metrics/metrics-icons.service';
import { setPageDirtyFlag } from 'src/app/shared/page-dirty-flag';
import { CreateSurveyFromScratchComponent } from 'src/app/components/create-survey-from-scratch/create-survey-from-scratch.component';
import { SurveyBuilderHelpModalComponent } from 'src/app/components/survey-builder-help-modal/survey-builder-help-modal.component';
import { CreateReferenceSurveyComponent } from 'src/app/components/create-reference-survey/create-reference-survey.component';
import { WarningModalService } from 'src/app/services/warning-modal/warning-modal.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import {
  SurveyUserPermissionModalComponent
} from "../../components/survey-user-permission-modal/survey-user-permission-modal.component";

@Component({
  selector: 'app-questionnaire',
  templateUrl: './questionnaire.component.pug',
  styleUrls: ['./questionnaire.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class QuestionnaireComponent implements OnInit, OnDestroy, AfterContentChecked {
  questions:any = [];
  questionnaireTitle:any = "";
  editTitleModal: BsModalRef = new BsModalRef();
  deletewarningModal: BsModalRef = new BsModalRef();
  addQuestionModal: BsModalRef = new BsModalRef();
  userPermissionModal: BsModalRef =  new BsModalRef();
  helpModal: BsModalRef = new BsModalRef();
  createCustomQuestionModal: BsModalRef = new BsModalRef();
  questionnaireId = '';
  is_additional_comments_enabled=true
  isNew = false;
  saveQuestionnaire = {};
  notSaved = true;
  maxLimit = 5;
  pulse_questionnaireGuideInformation = $localize`Surveys must include at least 1 question and not exceed the questions limit (${this.maxLimit}).`;
  questionnaireGuideInformation = $localize`Surveys must include at least 5 questions and not exceed your questions limit (${this.maxLimit}).`;
  referenceQuestionareEmployment = $localize`Please add questions to all reference types included in the survey. Reference types can be configured in `;
  referenceSettingsText = $localize`settings`;
  questionnaireTitleError = $localize`A survey with this title already exists, please try another. Note: you may not have access to view all surveys. Contact your account admin for support.`;
  org_name='';
  org_uid = Cookies.get(ConstantsService.ORG_COOKIE);
  attachToFooter= false;
  state:any ={};
  loading:any;
  persona_questions = {
    'candidate': [],
    'employment': [],
    'academic': [],
    'voluntary': [],
    'character': [],
    'exit': []
  }
  settings:any={};
  surveyType = 'exit';
  showGuide = false;
  category_map = QuestionnaireService.category_map;
  created_by_id = '';
  isAllowed = false;
  canManageRefSurvey = false;
  canManageExitSurvey = false;
  canManagePulseSurvey = false;
  canManageOwnRefSurvey = false;
  canManageOwnExitSurvey = false;
  canManageOwnPulseSurvey = false;
  survey_type_mapping = QuestionnaireService.survey_type_mapping;
  ent9977DateBasedSurveyNaming = false;

  isOptInQuestionEnabled:boolean = true;
  optInQuestion:string = ConstantsService.DEFAULT_OPT_IN_QUESTION

  minReferee = ConstantsService.DEFAULT_REFEREE_COUNT;
  noteToCandidate: string = '';
  noteToReferee: string = '';
  defaultNoteToCandidate: string = '';
  defaultNoteToReferee: string = '';

  noteToCandidateChange = false;
  noteToRefereeChange = false;
  questionnaireIsDefault = false;
  externalDisableAddButton = true;

  ent_10363_pulse_relaunch = false;

  org:any = {};

  constructor( private route: ActivatedRoute,
               private router: Router,
               private modalService: BsModalService,
               private questionnaireService: QuestionnaireService,
               private organisationService: OrganisationService,
               private metricIconService: MetricIconService,
               private alertList: AlertBannerService,
               private permission: PermissionsService,
               public ngZone: NgZone,
               private modal: WarningModalService ) {
                 if (window.innerHeight == document.body.offsetHeight) this.attachToFooter = true;
                 this.state = this.router?.getCurrentNavigation()?.extras?.state;
                 if(this.state){
                  localStorage.setItem('survey-builder-state', JSON.stringify(this.state));
                }
               }

  @HostListener('window:scroll', ['$event']) onWindowScroll(e) {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      //At bottom of page
      this.ngZone.run(() => { this.attachToFooter = true })
    } else if ((window.innerHeight + window.scrollY) < (document.body.offsetHeight-100)) {
      // No longer at bottom of page
      this.ngZone.run(() => { this.attachToFooter = false })
    }
  }

  ngOnInit(): void {
    this.ent9977DateBasedSurveyNaming = this.permission.isFeatureActivated('ent-9977-date-based-survey-naming');
    this.ent_10363_pulse_relaunch = this.permission.isFeatureActivated('ENT-10363-pulse-relaunch');
    if (!this.ent_10363_pulse_relaunch) {
      this.externalDisableAddButton = false;
    }
    const survey_type = localStorage.getItem('survey_type');
    if(survey_type) this.surveyType =  survey_type;
    setPageDirtyFlag(true);
    const stateStored = localStorage.getItem('survey-builder-state');
    if(!this.state && stateStored){
      this.state = JSON.parse(stateStored);
    }
    const isNew = this.state?.isNew;
    if (isNew) {
      this.isNew = isNew == true;
    }
    const questionnaireId = this.state?.questionnaireId;
    if (questionnaireId){
      this.questionnaireId = questionnaireId;
      this.questionnaireService.getQuestionnaire(questionnaireId).subscribe(
        res => {
          this.is_additional_comments_enabled = res?.data?.is_additional_comments_enabled;
          this.isOptInQuestionEnabled = this.isNew ? true : res?.data?.is_opt_in_question_enabled;
          this.optInQuestion = this.isNew ? ConstantsService.DEFAULT_OPT_IN_QUESTION : res?.data?.opt_in_question;

          this.minReferee = res?.data?.config?.min_referee? res?.data?.config?.min_referee : ConstantsService.DEFAULT_REFEREE_COUNT;
          this.noteToCandidate = res?.data?.config?.notes?.note_to_candidate? res.data.config.notes.note_to_candidate : '';
          this.noteToReferee = res?.data?.config?.notes?.note_to_referee ? res.data.config.notes.note_to_referee : '';

          if (this.ent_10363_pulse_relaunch && !this.isNew) {
            this.externalDisableAddButton = false;
          }

          //get orgdetails to set default note to candidate and referee

          this.organisationService.getOrganisation().subscribe((orgDetails) => {
            this.org = orgDetails;
            this.defaultNoteToCandidate = orgDetails?.notes?.note_to_candidate ?? '';
            this.defaultNoteToReferee = orgDetails?.notes?.note_to_referee ?? '';

            this.questionnaireIsDefault = res?.data?.questions?.[0]?.questionnaire?.is_default ?? false;
            if(this.questionnaireIsDefault){
              this.noteToCandidate = this.defaultNoteToCandidate;
              this.noteToReferee = this.defaultNoteToReferee;
            }

            this.noteToCandidateChange = this.noteToCandidate.trim() !== this.defaultNoteToCandidate;
            this.noteToRefereeChange = this.noteToReferee.trim() !== this.defaultNoteToReferee;
          }, error => {
            console.error('Failed to load organization details:', error);
            this.defaultNoteToCandidate = '';
            this.defaultNoteToReferee = '';
            this.alertList.append([{
              type: AlertType.WARNING,
              message: $localize`Failed to load default notes. Using empty defaults.`,
              keepOnRouteChange: false
            }]);
          })

          // When questionnaireId is not None, the user can create or edit surveys if they have the appropriate permissions.
          // If they do not have the appropriate permissions, the users will be redirected to the generic no-access page.
          this.created_by_id = res.data['created_by'];
          this.canManageRefSurvey = this.permission.hasPermission('can_manage_reference_surveys');
          this.canManageExitSurvey = this.permission.hasPermission('can_manage_exit_surveys');
          this.canManagePulseSurvey = this.permission.hasPermission('can_manage_pulse_surveys');
          this.canManageOwnRefSurvey = this.permission.hasPermission('can_manage_own_reference_surveys');
          this.canManageOwnExitSurvey = this.permission.hasPermission('can_manage_own_exit_surveys');
          this.canManageOwnPulseSurvey = this.permission.hasPermission('can_manage_own_pulse_surveys');
          const routePath = this.route.snapshot?.routeConfig?.path;
          const user_id = this.permission.data?.user_id;
          if (routePath == 'surveys/edit') {
            if (this.surveyType == 'reference') {
              this.isAllowed = this.canManageRefSurvey;
              if (this.canManageOwnRefSurvey && user_id == this.created_by_id) {
                this.isAllowed = true;
              }
            } else if (this.surveyType == 'pulse') {
              this.isAllowed = this.canManagePulseSurvey;
              if (this.canManageOwnPulseSurvey && user_id == this.created_by_id) {
                this.isAllowed = true;
              }
            } else if (this.surveyType == 'exit') {
              this.isAllowed = this.canManageExitSurvey;
              if (this.canManageOwnExitSurvey && user_id == this.created_by_id) {
                this.isAllowed = true;
              }
            }
          } else if (routePath == 'surveys/create') {
            if (this.surveyType == 'reference') {
              this.isAllowed = this.permission.hasPermission('can_create_reference_surveys');
            } else if (this.surveyType == 'pulse') {
              this.isAllowed = this.permission.hasPermission('can_create_pulse_surveys');
            } else if (this.surveyType == 'exit') {
              this.isAllowed = this.permission.hasPermission('can_create_exit_surveys');
            }
          }
          if (!this.isAllowed) {
            this.router.navigate(['/no-access']);
          }

          if (this.isNew){
            let name: string;

            // ENT-9977: Generate title with date and version number instead of (Copy)
            if (this.ent9977DateBasedSurveyNaming) {
              // Remove any existing (Copy) suffixes and date patterns from the original title
              let cleanName = res.data['name'];

              // Step 1: Remove all (Copy) suffixes
              cleanName = cleanName.replace(/\s*\(Copy\)\s*/g, ' ').trim();

              // Step 2: Remove trailing version numbers like (1), (2), etc.
              cleanName = cleanName.replace(/\s*\(\d+\)\s*$/, '').trim();

              // Step 3: Remove date patterns - handle both formats:
              // Format 1: "DD MMM YYYY" (e.g., "29 Oct 2025") - from ENT-9977
              // Format 2: "MMM D, YYYY" or "MMM DD, YYYY" (e.g., "Oct 29, 2025") - from generateQuestionnaireTitle
              cleanName = cleanName.replace(/\s+\d{1,2}\s+[A-Za-z]{3}\s+\d{4}\s*$/, '').trim(); // Format 1
              cleanName = cleanName.replace(/\s+[A-Za-z]{3}\s+\d{1,2},\s+\d{4}\s*$/, '').trim(); // Format 2

              // Add current date in format 'DD MMM YYYY'
              const dateString = moment().format('DD MMM YYYY');
              name = `${cleanName} ${dateString}`;
            } else {
              // Legacy behavior: append (Copy) to the title
              name = res.data['name'] + ' (Copy)';
            }

            this.verifyQuestionnaireTitle(name);
          } else {
            this.questionnaireTitle = res.data['name'];
          }
          this.questions = res.data['questions'];
          this.questions.forEach((q:any)=>{
            if (Object.keys(this.persona_questions).findIndex(k=>k==q['category'].toLowerCase())!=-1){
              this.persona_questions[q['category'].toLowerCase()].push(q)
              this.settings[q['category'].toLowerCase()]=true;
            }
          })
        }
      )
    } else if (!questionnaireId) {
      // Under these conditions, we would allow users based solely on their create_survey permissions.
      // When there is no questionnaireId, both routes, 'surveys/create' and 'surveys/edit', will result in creating a new survey.
      if (this.ent_10363_pulse_relaunch) {
        this.externalDisableAddButton = false;
      }
      if (this.surveyType == 'reference') {
        this.isAllowed = this.permission.hasPermission('can_create_reference_surveys');

        this.minReferee= this.state?.minReferee ?? ConstantsService.DEFAULT_REFEREE_COUNT;
        this.noteToCandidate = this.state?.noteToCandidate ?? '';
        this.noteToReferee = this.state?.noteToReferee ?? '';
        this.noteToCandidateChange = this.state?.noteToCandidateChange ?? false;
        this.noteToRefereeChange = this.state?.noteToRefereeChange ?? false;

      } else if (this.surveyType == 'pulse') {
        this.isAllowed = this.permission.hasPermission('can_create_pulse_surveys');
      } else if (this.surveyType == 'exit') {
        this.isAllowed = this.permission.hasPermission('can_create_exit_surveys');
      }
      if (!this.isAllowed) {
        this.router.navigate(['/no-access']);
      }
    }
    const questionnaireTitle = this.state?.questionnaireTitle;
    if (questionnaireTitle){
      this.questionnaireTitle = questionnaireTitle;
    } else if(!questionnaireId){
      this.generateQuestionnaireTitle();
    }
    const selectedMetrics = this.state?.selectedMetrics;
    if (selectedMetrics) {
      this.questionnaireService.getQuestionsMetrics(selectedMetrics, survey_type).subscribe(
        (res) => {
          this.questions = res.data;
        }
      )
    }
    this.organisationService.getOrganisation().subscribe(res => {
      if (this.surveyType == 'pulse') {
        this.maxLimit = res['pulse_questionnaire_limit'];
      }
      else if (this.surveyType == 'exit') {
        this.maxLimit = res['questionnaire_limit'];
      }

      this.org_name = res['brand_name'];
      this.setGuideInformation();
        this.questionnaireGuideInformation = $localize`Surveys must include at least 5 questions and not exceed your questions limit (${this.maxLimit}).`;
    })
    this.settings = this.state?.selectedRefType ? this.state?.selectedRefType: this.settings;
    this.setGuideInformation();
  }

  ngOnDestroy() {
    setPageDirtyFlag(false);
    localStorage.removeItem('survey-builder-state');
  }

  ngAfterContentChecked() {
    this.setGuideInformation();
  }

  setGuideInformation(){

    if (this.surveyType == 'pulse') {
      this.pulse_questionnaireGuideInformation = $localize`Surveys must include at least 1 question and not exceed the questions limit (${this.maxLimit}).`;
      this.showGuide = this.questions.length < 1 || this.questions.length > this.maxLimit;
    }

    else if (this.surveyType == 'exit') {
      this.questionnaireGuideInformation = $localize`Surveys must include at least 5 questions and not exceed your questions limit (${this.maxLimit}).`;
      this.showGuide = this.questions.length < 5 || this.questions.length > this.maxLimit;
    }

    else if(this.surveyType=='reference') {
        this.showGuide = false;
    }
    else {
      this.showGuide = !Object.keys(this.persona_questions).every(persona => {
        if(persona != 'candidate' && (this.settings[persona]||persona=='employment'))
        return this.persona_questions[persona].length;
        else return 1;
      })
    }
  }

  getMetricIcon(metric) {
    return this.metricIconService.getMetricIcon(metric);
  }

  generateQuestionnaireTitle(): void{
    let name = '';
    const dateString = moment().startOf('day').format('ll');
    if (this.surveyType == 'exit') name = $localize`Exit survey ` + dateString;
    if (this.surveyType == 'reference') name = $localize`Reference survey ` + dateString;
    if (this.surveyType == 'pulse') name = $localize`Pulse survey ` + dateString;
    this.verifyQuestionnaireTitle(name);
  }

  verifyQuestionnaireTitle(name): void{
    var regExp = /\(([^)]*)\)[^(]*$/;
    this.questionnaireService.getNewQuestionnaireTitle(name).subscribe(res=>{
      const next = res['questionnaires'].map(q=> {
        const matches = regExp.exec(q['name']);
        if (matches?.length==2 && !isNaN(Number(matches[1]))) return Number(matches[1]);
        return 0;
      }).sort()[res['questionnaires'].length-1]+1;
      if (next) this.questionnaireTitle = name + ` (${next})`;
      else this.questionnaireTitle = name;

      // Open the settings modal on duplicate and edit
      if (this.state?.questionnaireId && this.route.snapshot?.routeConfig?.path == 'surveys/create'){
        this.onEditQuestionnaireTitle()
      }
      return name;
    })
    }

  onEditQuestionnaireTitle(): void {
    if (this.surveyType == 'exit' || this.surveyType == 'pulse') {
      const initialState = {
        'questionnaireId': this.questionnaireId,
        'questionnaireTitle': this.questionnaireTitle,
        'isEditTitle': true
      };
      if (this.ent_10363_pulse_relaunch) {
        this.externalDisableAddButton = false;
      }
      this.editTitleModal = this.modalService.show(
        CreateSurveyFromScratchComponent,
        {class: 'modal-dialog-centered modal-dialog-scrollable create-from-scratch', initialState},
      );
      this.editTitleModal.content.closeBtnName = 'Close';
      this.editTitleModal.content.nextClick.subscribe((res) => {
        this.questionnaireTitle = res.title;
      });
    } else if (this.surveyType == 'reference') {
      const initialState: any = {
        questionnaireId: this.questionnaireId,
        questionnaireTitle: this.questionnaireTitle,
        isEditTitle: true,
        selectedRefType: { ...this.settings },
        ...({
          isOptInQuestionEnabled: this.isOptInQuestionEnabled,
          optInQuestion: this.optInQuestion,
        }),
        ...({
          minReferee: this.minReferee,
          noteToCandidate: this.noteToCandidate,
          noteToReferee: this.noteToReferee,
          defaultNoteToCandidate: this.defaultNoteToCandidate,
          defaultNoteToReferee: this.defaultNoteToReferee,
        })
      };


      if (this.ent_10363_pulse_relaunch) {
        this.externalDisableAddButton = false;
      }
      this.editTitleModal = this.modalService.show(
        CreateReferenceSurveyComponent,
        {class: 'modal-dialog-centered xl-popup', initialState},
      );
      this.editTitleModal.content.closeBtnName = 'Close';
      this.editTitleModal.content.nextClick.subscribe((res) => {
        this.onSettingsChange(res);
        this.questionnaireTitle = res.title;
        this.isOptInQuestionEnabled=res.isOptInQuestionEnabled;
        this.optInQuestion = res.optInQuestion;

        this.minReferee = res.minReferee;
        this.noteToCandidate = res.noteToCandidate;
        this.noteToReferee = res.noteToReferee;
        this.noteToCandidateChange = res.noteToCandidateChange;
        this.noteToRefereeChange = res.noteToRefereeChange;
      });
    }
  }

  onSettingsChange(setting){
    if(setting.selectedRefType){
      let donotChange = false;
      for (let per in setting.selectedRefType){
        if(!setting.selectedRefType[per] &&
          this.settings[per] != setting.selectedRefType[per] &&
          this.persona_questions[per].length){
          donotChange = true;
        }
      }
      if (donotChange) {
        const title = $localize`Remove reference type?`
        const message = $localize`You are about to remove one or more reference types from this survey. By proceeding, all questions associated with these reference types will be deleted.\n\nAre you sure you want to proceed?`
        this.modal.confirm(
          title,
          message,
          false, $localize`Cancel`, $localize`Yes`).subscribe(res=>{
          if(res){
            this.settings = setting.selectedRefType;
            //only on click of yes update settings and flush the persona_questions
            Object.keys(this.settings).forEach(per=>{
              this.persona_questions[per] = setting.selectedRefType[per] ? this.persona_questions[per] : [];
            })
            return;
          } else {
            return;
          }
        })
      } else {
        this.settings = setting.selectedRefType;
      }
      this.setGuideInformation();
    }
  }

  onHelpOpen(): void {
    const initialState = {
      'type': this.surveyType
    }
    this.helpModal = this.modalService.show(
      SurveyBuilderHelpModalComponent,
      { class: 'modal-dialog-centered m-popup', initialState},
    )
    this.helpModal.content.closeBtnName = 'Close';
  }

  onQuestionChange(questions, type){
    if (type!='exit'){
      this.persona_questions[type] = questions;
    }
    this.questions = questions;
    this.setGuideInformation()
  }

  isDirty(): boolean {
    return this.notSaved;
  }

  cancel(){
    this.router.navigate(['surveys']);
  }

  onSaveQuestionnaire(): void {
    this.loading = true;
    const questionnaireBody = {
      'questions': <any>[],
      'name': ''
    };
    if(this.surveyType=='exit' || this.surveyType == 'pulse'){
      this.questions.forEach((question, index) =>{
      questionnaireBody.questions.push({
        'id': question.id,
        'order': index+1
        });
      });
    } else if (this.surveyType=="reference"){
      Object.keys(this.persona_questions).forEach(persona=>{
        this.persona_questions[persona].forEach((question,index)=>{
          questionnaireBody.questions.push({
            'id': question.id,
            'order': index+1,
            'category': this.category_map[persona],
          })
        })
      })
    }
    questionnaireBody['name'] = this.questionnaireTitle;

    // Record the questionnaireID param in postQuestionnaire for audit logs if it's duplication process
    if ( this.isNew || this.questionnaireId=='')
    {
      this.questionnaireService.postQuestionnaire(
      questionnaireBody,
      this.surveyType,
      this.questionnaireId,
      this.is_additional_comments_enabled,
      this.isOptInQuestionEnabled,
      this.optInQuestion,
      this.minReferee,
      this.noteToCandidate,
      this.noteToReferee
      ).subscribe(res => {
        this.saveQuestionResponseHandler(res);
      },
      err => {
        if (err.status == 400) {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: this.questionnaireTitleError,
            keepOnRouteChange: true
          }]);
          this.loading = false
        } else if (err.status == 500) {
          if (err.error.message.includes("duplicate key value violates unique constraint")) {
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`A survey with this title already exists, please try another.`,
              keepOnRouteChange: true
            }]);
            this.loading = false;
          } else {
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
            this.loading = false
          }
        }
      });

    }

    if (!this.isNew && (this.questionnaireId != '')) {

      this.questionnaireService.putQuestionnaire(
        this.questionnaireId,
        questionnaireBody,
        this.surveyType,
        this.is_additional_comments_enabled,
        this.isOptInQuestionEnabled,
        this.optInQuestion,
        this.minReferee,
        this.noteToCandidate,
        this.noteToReferee
      ).subscribe(res => {
          this.saveQuestionResponseHandler(res);
        },
        err => {
          if (err.status == 400) {
            this.loading = false;
            this.alertList.append([{
              type: AlertType.DANGER,
              message: this.questionnaireTitleError,
              keepOnRouteChange: true
            }]);
          } else if (err.status == 500) {
            this.loading = false;
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          }
      });
    }
  }

  getSurveyType(surveyType) {
    return surveyType ? surveyType.charAt(0).toUpperCase() + surveyType.slice(1) : "-";
  }

  saveQuestionResponseHandler(res){
    if ( res['status_message'] == "ok" ) {
      this.loading=false;
      setPageDirtyFlag(false)
      this.notSaved = false;
      let questionnaireId = '';
      const isNewQuestionnaire = this.isNew || this.questionnaireId == '';
      if (isNewQuestionnaire){
        questionnaireId = res['data']['id'];
      } else{
        questionnaireId = this.questionnaireId;
      }
      const initialState = {
        'questionnaireId': questionnaireId,
        'isNewQuestionnaire': isNewQuestionnaire
      };


      initialState['questionnaireTitle'] = res['data']['name'];
      initialState['questionnaireProduct'] = this.getSurveyType(res['data']['survey_type']);

      this.userPermissionModal = this.modalService.show(
          SurveyUserPermissionModalComponent,
          {class: 'modal-dialog-centered xl-popup', initialState},
      );

      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Survey was saved successfully`,
        keepOnRouteChange: true
      }]);

      this.router.navigate(['surveys']);

    } else {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    }

  }
  onToggleEvent(isToggled:boolean){
    this.is_additional_comments_enabled=isToggled
  }

  hasEmploymentQuestions(): boolean {
    if (this.surveyType === 'reference') {
      const requiredTypes = ['character', 'academic', 'voluntary'];
      for (const type of requiredTypes) {
        if (this.settings?.[type] && (!this.persona_questions[type] || this.persona_questions[type].length === 0)) {
          return false;
        }
      }
    }
    return this.persona_questions['employment'] && this.persona_questions['employment'].length > 0;
  }
}
